(async () => {

  if (!customElements.get('cart-collection-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay, Mousewheel } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Mousewheel,
      Autoplay
    ]);

    class CartFeaturedCollection extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          spaceBetween: 0,
          slidesPerView: 1,
          direction: 'horizontal',
          mousewheel: true,
          threshold: 10,
          breakpoints: {
            320: {
              slidesPerView: 1
            },
            375: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4
            }
          }
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperInstance.update();
          });
        }
      }
    }
    window.CartFeaturedCollection = CartFeaturedCollection;
    customElements.define('cart-collection-swiper', CartFeaturedCollection);
  }
})();